import {
  FETCH_CONVERSATIONS,
  FETCH_CONVERSATION,
  CREATE_CONVERSATION,
  UPDATE_CONVERSATION,
  DELETE_CONVERSATION,
  FETCH_MESSAGES,
  SEND_MESSAGE,
  DELETE_MESSAGE,
  ADD_PARTICIPANT,
  REMOVE_PARTICIPANT,
  FETCH_UNREAD_COUNT,
  MARK_AS_READ,
  UPLOAD_MESSAGE_ATTACHMENT,
  DELETE_MESSAGE_ATTACHMENT,
  MESSAGING_ERROR,
  MESSAGING_LOADING,
} from "../actions/constants";

const initialState = {
  conversations: [],
  currentConversation: null,
  messages: {},
  unreadCounts: {},
  totalUnreadCount: 0,
  loading: false,
  error: null,
};

const messagingReducer = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGING_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case MESSAGING_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_CONVERSATIONS:
      return {
        ...state,
        // Handle the nested structure of the API response
        conversations: action.payload.data?.conversations || [],
        totalUnreadCount: action.payload.data?.totalUnreadCount || 0,
        loading: false,
        error: null,
      };

    case FETCH_CONVERSATION:
      return {
        ...state,
        currentConversation: action.payload,
        loading: false,
        error: null,
      };

    case CREATE_CONVERSATION:
      return {
        ...state,
        conversations: [action.payload, ...state.conversations],
        currentConversation: action.payload,
        loading: false,
        error: null,
      };

    case UPDATE_CONVERSATION:
      return {
        ...state,
        conversations: state.conversations.map((conversation) =>
          conversation._id === action.payload._id
            ? action.payload
            : conversation
        ),
        currentConversation:
          state.currentConversation?._id === action.payload._id
            ? action.payload
            : state.currentConversation,
        loading: false,
        error: null,
      };

    case DELETE_CONVERSATION:
      return {
        ...state,
        conversations: state.conversations?.filter(
          (conversation) => conversation._id !== action.payload
        ),
        currentConversation:
          state.currentConversation?._id === action.payload
            ? null
            : state.currentConversation,
        messages: {
          ...state.messages,
          [action.payload]: undefined,
        },
        loading: false,
        error: null,
      };

    case FETCH_MESSAGES:
      const { conversationId, messages, hasMore, page } = action.payload;
      return {
        ...state,
        messages: {
          ...state.messages,
          [conversationId]: {
            data:
              page === 1
                ? messages
                : [
                    ...(state.messages[conversationId]?.data || []),
                    ...messages,
                  ],
            hasMore,
            currentPage: page,
          },
        },
        loading: false,
        error: null,
      };

    case SEND_MESSAGE:
      const { conversationId: convId, message } = action.payload;
      return {
        ...state,
        messages: {
          ...state.messages,
          [convId]: {
            ...state.messages[convId],
            data: [message, ...(state.messages[convId]?.data || [])],
          },
        },
        conversations: state.conversations.map((conversation) => {
          if (conversation._id === convId) {
            return {
              ...conversation,
              lastMessageAt: message.createdAt,
              lastMessageText: message.text,
              lastMessageSender: message.sender,
            };
          }
          return conversation;
        }),
        loading: false,
        error: null,
      };

    case DELETE_MESSAGE:
      const { conversationId: cId, messageId } = action.payload;
      return {
        ...state,
        messages: {
          ...state.messages,
          [cId]: {
            ...state.messages[cId],
            data:
              state.messages[cId]?.data.filter(
                (msg) => msg._id !== messageId
              ) || [],
          },
        },
        loading: false,
        error: null,
      };

    case ADD_PARTICIPANT:
      const { conversationId: convIdAdd, participant } = action.payload;
      return {
        ...state,
        conversations: state.conversations.map((conversation) => {
          if (conversation._id === convIdAdd) {
            return {
              ...conversation,
              participants: [...conversation.participants, participant],
            };
          }
          return conversation;
        }),
        currentConversation:
          state.currentConversation?._id === convIdAdd
            ? {
                ...state.currentConversation,
                participants: [
                  ...state.currentConversation.participants,
                  participant,
                ],
              }
            : state.currentConversation,
        loading: false,
        error: null,
      };

    case REMOVE_PARTICIPANT:
      const { conversationId: convIdRemove, userId } = action.payload;
      return {
        ...state,
        conversations: state.conversations.map((conversation) => {
          if (conversation._id === convIdRemove) {
            return {
              ...conversation,
              participants: conversation.participants.filter(
                (p) => p.user._id !== userId
              ),
            };
          }
          return conversation;
        }),
        currentConversation:
          state.currentConversation?._id === convIdRemove
            ? {
                ...state.currentConversation,
                participants: state.currentConversation.participants.filter(
                  (p) => p.user._id !== userId
                ),
              }
            : state.currentConversation,
        loading: false,
        error: null,
      };

    case FETCH_UNREAD_COUNT:
      return {
        ...state,
        // Handle the new API response format from the updated endpoint
        totalUnreadCount: action.payload.data?.count || action.payload.count || 0,
        loading: false,
        error: null,
      };

    case MARK_AS_READ:
      return {
        ...state,
        unreadCounts: {
          ...state.unreadCounts,
          [action.payload]: 0,
        },
        totalUnreadCount: Math.max(
          0,
          state.totalUnreadCount - (state.unreadCounts[action.payload] || 0)
        ),
        conversations: state.conversations.map((conversation) => {
          if (conversation._id === action.payload) {
            return {
              ...conversation,
              participants: conversation.participants.map((p) => {
                if (
                  p.user._id ===
                  JSON.parse(localStorage.getItem("profile"))?.result?._id
                ) {
                  return { ...p, unreadCount: 0 };
                }
                return p;
              }),
            };
          }
          return conversation;
        }),
        loading: false,
        error: null,
      };

    case UPLOAD_MESSAGE_ATTACHMENT:
      // The attachment will be used when sending a message, so we just update loading state
      return {
        ...state,
        loading: false,
        error: null,
      };

    case DELETE_MESSAGE_ATTACHMENT:
      return {
        ...state,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default messagingReducer;
